import React from "react";
import { TableCell } from "../core/pdf/types";

export interface TableCellState {
	cell: TableCell,
}

export const TableCellContext = React.createContext<TableCellState | undefined>(undefined);

export function useTableCell() {
	return React.useContext(TableCellContext);
}
